import createApp from 'createApp'

createApp({})